import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { BookingFieldsetComponent } from "./booking-fieldset.component";
import { JourneyFieldsetComponent } from "./journey-fieldset.component";
import { TravellerFieldsetComponent } from "./traveller-fieldset.component";
import { ButtonModule } from "libraries/module/formbuilder/fields/button/button.module";
import { ChipsModule } from "libraries/module/formbuilder/fields/chips/chips.module";
import { MultiselectModule } from "libraries/module/formbuilder/fields/multiselect/multiselect.module";
import { DateRangeModule } from "libraries/module/formbuilder/fields/date-range/date-range.module";
import { ViewsModule } from "libraries/view/views.module";
import { FieldDescriptionModule } from "libraries/module/formbuilder/fields/form-field/components/field-description/field-description.module";
import { DateFieldSetModule } from "../../date-field-set/date-field-set.module";
import { CollapsibleModule } from "libraries/component/collapsible/collapsible.module";
import { FlightFieldsetComponent } from "./flight-fieldset.component";
import { DocumentFieldsetComponent } from "./document-fieldset.component";
import { PricingFieldsetComponent } from "./pricing-fieldset.component";
import { ServiceFieldsetComponent } from "./service-fieldset.component";
import { BookingStatusModule } from "libraries/component/booking/booking-status/booking-status.module";
import { AfidiumServiceFieldsetComponent } from "./afidium-service-fieldset.component";
import { AfidiumServiceFieldModule } from "../../afidium-service-field/afidium-service-field.module";
import { RemarkFieldsetComponent } from "./remark-fieldset.component";
import { CheckboxFieldModule } from "libraries/module/formbuilder/fields/checkbox-field/checkbox-field.module";
import { VoucherFieldsetComponent } from "./voucher-fieldset.component";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { NumberModule } from "libraries/module/formbuilder/fields/number/number.module";
import { PermissionModule } from "libraries/permission/permission.module";
import { ModifyFieldConfigLabelModule } from "libraries/pipes/modify-field-config-label/modify-field-config-label.module";
import {AccomodationFieldsetComponent} from "./accomodation-fieldset.component";
import {QualityCheckFieldsetComponent} from "./quality-check-fieldset.component";
import {
    CheckboxGroupFieldModule
} from "../../../../../libraries/module/formbuilder/fields/checkbox-group-field/checkbox-group-field.module";
import {FareOptimisationFieldsetComponent} from "./fare-optimisation-fieldset.component";

@NgModule({
    declarations: [
        AccomodationFieldsetComponent,
        AfidiumServiceFieldsetComponent,
        BookingFieldsetComponent,
        DocumentFieldsetComponent,
        FlightFieldsetComponent,
        JourneyFieldsetComponent,
        PricingFieldsetComponent,
        QualityCheckFieldsetComponent,
        RemarkFieldsetComponent,
        ServiceFieldsetComponent,
        TravellerFieldsetComponent,
        VoucherFieldsetComponent,
        FareOptimisationFieldsetComponent,
    ],
    imports: [
        AfidiumServiceFieldModule,
        BookingStatusModule,
        ButtonModule,
        CheckboxFieldModule,
        CheckboxGroupFieldModule,
        ChipsModule,
        ChipsModule,
        CollapsibleModule,
        CommonModule,
        DateFieldSetModule,
        DateRangeModule,
        FieldDescriptionModule,
        FontAwesomeModule,
        ModifyFieldConfigLabelModule,
        MultiselectModule,
        NumberModule,
        PermissionModule,
        ReactiveFormsModule,
        ViewsModule,
    ],
    exports: [
        BookingFieldsetComponent,
        JourneyFieldsetComponent,
        TravellerFieldsetComponent,
        FlightFieldsetComponent,
        DocumentFieldsetComponent,
        PricingFieldsetComponent,
        ServiceFieldsetComponent,
        AfidiumServiceFieldsetComponent,
        RemarkFieldsetComponent,
        VoucherFieldsetComponent,
        AccomodationFieldsetComponent,
        QualityCheckFieldsetComponent,
        FareOptimisationFieldsetComponent,
    ],
})
export class FieldsetsModule {
}
